import { render, staticRenderFns } from "./RoleView.vue?vue&type=template&id=35561f09&lang=pug&"
import script from "./RoleView.vue?vue&type=script&lang=js&"
export * from "./RoleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports